import request from '@/utils/request'

const CommonApi = {
    listRegion() {
        return request.post('/common/listregion');
    },
    createsign(url) {
        return request.post('/common/createsign', {url:url});
    }
}

export default CommonApi;

